// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.callDoctor{
    margin: 3px;
    padding: 7px 10px 7px 10px;
    border-radius: 10px;
    background-color: aliceblue;
}

.finishTreatment{
    margin: 3px;
    padding: 7px 10px 7px 10px;
    border-radius: 10px;
    background-color: rgb(255, 240, 240);
    color: black;

}

.detailsTableButtons{
    display: flex;
    justify-content: center;
}

.noData{
    padding: 10px;
    border-radius: 20px;
    width: 500px;
}`, "",{"version":3,"sources":["webpack://./src/components/QueuesManagment/PatientAndQueueDetails.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,0BAA0B;IAC1B,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,mBAAmB;IACnB,oCAAoC;IACpC,YAAY;;AAEhB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":[".callDoctor{\r\n    margin: 3px;\r\n    padding: 7px 10px 7px 10px;\r\n    border-radius: 10px;\r\n    background-color: aliceblue;\r\n}\r\n\r\n.finishTreatment{\r\n    margin: 3px;\r\n    padding: 7px 10px 7px 10px;\r\n    border-radius: 10px;\r\n    background-color: rgb(255, 240, 240);\r\n    color: black;\r\n\r\n}\r\n\r\n.detailsTableButtons{\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.noData{\r\n    padding: 10px;\r\n    border-radius: 20px;\r\n    width: 500px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
